import { useState } from 'react';
import styled from 'styled-components';
import { devices } from '../helpers/devices';
import useScrollTo from '../helpers/useScrollTo';

const Section = styled.section`
    margin: 0 8rem 2rem 8rem;

    & article {
        margin-bottom: 3rem;
    }

    & h2 {
        color: ${props => props.theme.headerTextColor1};
        margin-bottom: 1rem;
        text-transform: uppercase;
    }

    & a {
        display: block;
        width: max-content;
        margin-bottom: .5rem;
    }

    & p {
        margin-top: 1rem;
        color: ${props => props.theme.gray2}
    }

    @media ${devices.laptop} {
        margin: 0 2rem 1rem 2rem;
    }
    `;


const ServicosCompletoSection = (): JSX.Element => {
    const [demonstrativos] = useState([
        {
            description: "Demonstrativos de 30 de junho de 2026",
            link: "https://dascam.s3.us-east-1.amazonaws.com/INF901065645137062026.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2025",
            link: "https://dascam.s3.us-east-1.amazonaws.com/INF901065645137122025.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2025",
            link: "https://dascam.s3.us-east-1.amazonaws.com/INF901065645137062025.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2024",
            link: "https://dascam.s3.us-east-1.amazonaws.com/INF90106564513722024.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2024",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2024.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2023",
            link: "https://dascam.s3.amazonaws.com/demostrativos/31_12_23.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2023",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2023.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2022",
            link: "https://dascam.s3.amazonaws.com/demostrativos/31_12_2022.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2022",
            link: "https://dascam.s3.amazonaws.com/demostrativos/30_06_2022.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2021",
            link: "https://dascam.s3.amazonaws.com/demostrativos/12_2021.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2021",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2021.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2020",
            link: "https://dascam.s3.amazonaws.com/demostrativos/31_12_2020.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2020",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2020.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2019",
            link: "https://dascam.s3.amazonaws.com/demostrativos/12_2019.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2019",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2019.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2018",
            link: "https://dascam.s3.amazonaws.com/demostrativos/12_2018.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2018",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2018.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2017",
            link: "https://dascam.s3.amazonaws.com/demostrativos/12_2017.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2017",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2017.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2016",
            link: "https://dascam.s3.amazonaws.com/demostrativos/12_2016.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2016",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2016.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2015",
            link: "https://dascam.s3.amazonaws.com/demostrativos/12_2015.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2015",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2015.pdf",
        },
        {
            description: "Demonstrativos de 31 de dezembro de 2014",
            link: "https://dascam.s3.amazonaws.com/demostrativos/12_2014.pdf",
        },
        {
            description: "Demonstrativos de 30 de junho de 2014",
            link: "https://dascam.s3.amazonaws.com/demostrativos/06_2014.pdf",
        },
    ]);
       
    const demonstrativosFinanceirosRef = useScrollTo<HTMLHeadingElement>("#demonstrativos_financeiros", { behavior: "smooth", block: "start" });

    return (
        <Section>
            <article>
                <h2 ref={demonstrativosFinanceirosRef}>Demonstrativos Financeiros</h2>
                {demonstrativos.map(item => (
                    <a key={item.link} href={item.link} target="_blank" rel="noreferrer noopener">{item.description}</a>
                ))}
            </article>
        </Section>
    )
};

export default ServicosCompletoSection;